import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-bottom",
  "use": "icon-bottom-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-bottom\"><defs><style type=\"text/css\"></style></defs><path d=\"M533.931498 739.588415c-12.692067 12.692067-33.187867 12.773931-45.778626 0.184195L74.382081 326.000795c-12.590759-12.590759-12.507872-33.086559 0.184195-45.778626l0 0c12.692067-12.692067 33.187867-12.773931 45.778626-0.184195l413.771815 413.771815C546.70543 706.400548 546.623565 726.896348 533.931498 739.588415L533.931498 739.588415zM947.851693 281.262872c12.692067 12.692067 12.773931 33.187867 0.184195 45.778626L534.264073 740.812289c-12.590759 12.590759-33.086559 12.507872-45.778626-0.184195l0 0c-12.692067-12.692067-12.773931-33.187867-0.184195-45.778626l413.770791-413.770791C914.663826 268.48894 935.159626 268.570805 947.851693 281.262872L947.851693 281.262872z\" p-id=\"2556\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/bottom.svg
// module id = TiQc
// module chunks = 31